// Автобусы
// 2- ж/д вокзал-университет-комплекс юбилейный
// 35-речной вокзал-университет-больничный комплекс

// Троллейбусы
// 8А-Волгоградский оптово-строительный рынок-университет-инструментальный завод
// 9-детский центр-университет-нижний посёлок ВГТЗ
// 8К-детский центр-университет-нижний поселок ВГТЗ
// 10А-спартановка-университет-жилгородок

export const userLocation = {
  vstu: "Технический",
  vspu: "Педагогический",
};

export const linkToLocation = {
  [userLocation.vstu]: "/vstu",
  [userLocation.vspu]: "/vspu",
};

export const transportType = [
  {type: "Автобус", img : "bus.png"},
  {type: "Маршрутка", img : "minibus.png"},
  {type: "СТ", img : "st.png"},
  {type: "Троллейбус", img : "trolleybus.png"},
]

const data = {
  bus: {
    properties: {
      vstu: [
        {
          name: "2",
          type: "Автобус",
          startFrom: "Волгоград – Железнодорожный вокзал",
        },
        {
          name: "35",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "79",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "55",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "59",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "48",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "77",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "55",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "48",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "43",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "25",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "21",
          type: "Автобус",
          startFrom: "Речпорт",
        },
        {
          name: "8А",
          type: "Троллейбус",
          startFrom: "Волгоградский оптово-строительный рынок",
        },
        {
          name: "9",
          type: "Троллейбус",
          startFrom: "Детский центр",
        },
        {
          name: "8К",
          type: "Троллейбус",
          startFrom: "Детский центр",
        },
        {
          name: "10А",
          type: "Троллейбус",
          startFrom: "Улица Грамши",
        },
        {
          name: "9К",
          type: "Троллейбус",
          startFrom: "Улица Грамши",
        },
        {
          name: "15А",
          type: "Троллейбус",
          startFrom: "Улица Грамши",
        },
        {
          name: "СТ",
          type: "Трамвай",
          startFrom: "Улица Грамши",
        },
        {
          name: "СТ2",
          type: "Трамвай",
          startFrom: "Улица Грамши",
        },
        {
          name: "1",
          type: "Трамвай",
          startFrom: "Улица Грамши",
        },
        {
          name: "7",
          type: "Трамвай",
          startFrom: "Улица Грамши",
        },
        {
          name: "11",
          type: "Трамвай",
          startFrom: "Улица Грамши",
        },
        {
          name: "46С",
          type: "Маршрутка",
          startFrom: "Улица Грамши",
        },
        {
          name: "3С",
          type: "Маршрутка",
          startFrom: "Улица Грамши",
        },
        {
          name: "160",
          type: "Маршрутка",
          startFrom: "Улица Грамши",
        },
        {
          name: "260",
          type: "Маршрутка",
          startFrom: "Улица Грамши",
        },
        {
          name: "149",
          type: "Маршрутка",
          startFrom: "Улица Грамши",
        },
        {
          name: "179",
          type: "Маршрутка",
          startFrom: "Улица Грамши",
        },
      ],
      vspu: [
        {
          name: "2",
          type: transportType.bus,
          startFrom: "Комплекс Юбилейный",
        },
        {
          name: "35",
          type: transportType.bus,
          startFrom: "Больничный комплекс",
        },
        {
          name: "8А",
          type: transportType.trolleybus,
          startFrom: "Инструментальный завод",
        },
        {
          name: "9",
          type: transportType.trolleybus,
          startFrom: "Нижний посёлок ВгТЗ",
        },
        {
          name: "8К",
          type: transportType.trolleybus,
          startFrom: "Нижний посёлок ВгТЗ",
        },
        {
          name: "10А",
          type: transportType.trolleybus,
          startFrom: "Школа №61",
        },
      ],
    },
  },
};

export default data;
